import { registerSW } from 'virtual:pwa-register';

export default defineNuxtPlugin(() => {
  if (!process.client) {
    return;
  }

  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      window.dispatchEvent(new CustomEvent('pwa:need-refresh'));
    },
    onOfflineReady() {
      window.dispatchEvent(new CustomEvent('pwa:offline-ready'));
    },
    onRegisteredSW(swUrl) {
      console.info('[pwa] service worker registered', swUrl);
    },
    onRegisterError(error) {
      console.error('[pwa] service worker registration error', error);
    },
  });

  window.addEventListener('focus', () => updateSW());

  const ensureNotificationPermission = async () => {
    if (!('Notification' in window)) {
      return;
    }
    if (Notification.permission === 'default') {
      try {
        await Notification.requestPermission();
      } catch (err) {
        console.warn('[pwa] notification permission error', err);
      }
    }
  };

  ensureNotificationPermission();
});

